module.exports = "images/vertical-ladder-rung-de85038fecff06f39f5b6629d22e521f.png";